import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";

import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import LabelAndInputDateCalendar from "../common/form/labelAndInputDateCalendar";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";

import { initForm, setModoTela } from "./usuarioActions";
import { getLista as getListaCliente, getListaClienteSelect } from "../cliente/clienteActions";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import TBody from "../common/table/tBody";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import Td from "../common/table/td";
import Select from "../common/form/select";
import { getListaSelect as getListaEmpresa } from "../empresa/empresaActions";
import { Loading } from "../common/loading/loading";

function UsuarioForm(props) {
    const [state, setState] = useState({ exibirCampoNovaSenha: false });

    useEffect(() => {
        props.getListaClienteSelect();
        props.getListaCliente(props.registro);
        props.getListaEmpresa();
    }, []);

    const readOnly = props.excluir;

    //se o usuário pertence a um cliente, deve alterar a empresa do cliente
    //para que seja alterada a empresa de todos usuários vinculados ao cliente
    const readOnlySelectEmpresa = readOnly || props.registro.id_cliente || props.usuarioLogado.id_empresa;

    const readOnlyImplantacao = readOnly || props.registro.id_cliente;

    return (
        <ContentCard>
            {props.aguardandoClientes ? <Loading /> : null}
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    <Field
                        name="id_empresa"
                        component={Select}
                        label={"Empresa" + (props.usuarioLogado.id_empresa ? " * " : "")}
                        options={props.listaEmpresa}
                        placeholder="Informe a Empresa"
                        cols="12 12 12 12"
                        readOnly={readOnlySelectEmpresa}
                    />
                    {props.registro.id_cliente && (
                        <Field name="id_cliente" component={Select} label="Cliente" options={props.listaClienteSelect} cols="12 12 12 12" readOnly={true} />
                    )}

                    <Field name="nome" component={LabelAndInput} label="Nome *" placeholder="Informe o Nome" cols="12 12 12 12" readOnly={readOnly} />

                    <Field name="login" component={LabelAndInput} label="Login *" placeholder="Informe o Usuário" cols="12 12 12 12" readOnly={readOnly} />

                    <Field
                        name="data_nascimento"
                        component={LabelAndInputDateCalendar}
                        label="Data de nascimento *"
                        cols="12 12 12 12"
                        readOnly={readOnly}
                    />

                    {props.formularioValues.id ? null : (
                        <Field name="senha" component={LabelAndInput} type="password" label="Senha *" placeholder="Informe a senha" cols="12 12 12 12" readOnly={readOnly} />
                    )}
                    <Field
                        style={{ marginRight: 10 }}
                        name="usuario_implantacao"
                        component={LabelAndCheckbox}
                        label="Usuário Implantação *"
                        cols="12 12 12 12"
                        readOnly={readOnlyImplantacao}
                    />

                    {props.formularioValues.id ? (
                        <ContentCard>
                            <Row style={{ padding: 12 }}>
                                {state.exibirCampoNovaSenha ? (
                                    <>
                                        <Grid cols="6 6 4 3" style={{ padding: "10px 0px" }}>
                                            <Button
                                                text="Cancelar"
                                                type={"danger"}
                                                icon={"fa fa-times"}
                                                event={() => {
                                                    setState({ ...state, exibirCampoNovaSenha: false });
                                                    props.initForm({ ...props.formularioValues, senha_atual: undefined, nova_senha: undefined });
                                                }}
                                            />
                                        </Grid>

                                        <Field
                                            name="senha_atual"
                                            component={LabelAndInput}
                                            type="password"
                                            label="Senha Atual *"
                                            placeholder="Informe a senha atual"
                                            cols="12 12 12 12"
                                            readOnly={readOnly}
                                        />
                                        <Field
                                            name="nova_senha"
                                            component={LabelAndInput}
                                            type="password"
                                            label="Nova Senha *"
                                            placeholder="Informe a nova senha"
                                            cols="12 12 12 12"
                                            readOnly={readOnly}
                                        />
                                    </>
                                ) : (
                                    <Grid cols="6 6 4 3" style={{ padding: "10px 0px" }}>
                                        <Button
                                            text="Alterar Senha"
                                            type={"dark"}
                                            icon={"fa fa-pencil-alt"}
                                            event={() => {
                                                setState({ ...state, exibirCampoNovaSenha: true });
                                                props.initForm({ ...props.formularioValues, senha_atual: null, nova_senha: null });
                                            }}
                                        />
                                    </Grid>
                                )}
                            </Row>
                        </ContentCard>
                    ) : null}
                </ContentCardBody>

                <ContentCardFooter style={{ background: "transparent" }}>
                    <Row alignCenter>
                        <Grid cols="6 6 4 3">
                            {props.excluir ? (
                                <Button text="Excluir" submit type={"danger"} icon={"fa fa-trash"} />
                            ) : (
                                <Button text="Salvar" submit type={"success"} icon={"fa fa-check"} />
                            )}
                        </Grid>
                        <Grid cols="6 6 4 3">
                            <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setModoTela("lista")} />
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
            {props.registro.usuario_implantacao && (
                <div style={{ margin: 25 }}>
                    <b>Clientes e Unidades do Usuário de Implantação</b>
                    <Table>
                        <THead>
                            <Tr>
                                <Th>Cliente</Th>
                                <Th>Unidade Consumidora</Th>
                            </Tr>
                        </THead>
                        {props.listaClientes
                            .filter((cli) => !cli.bloquearEdicaoClienteUsuarioImplantacao)
                            .map((cliente) => {
                                const ucs = cliente.itens.filter((uc) => !uc.bloquearEdicaoUcUsuarioImplantacao);
                                if (!ucs.length) return null;
                                return (
                                    <TBody>
                                        <Tr>
                                            <Td paddingInline={15} rowspan={ucs.length + 1}>
                                                {cliente.nome}
                                            </Td>
                                        </Tr>
                                        {ucs.map((uc, i) =>
                                            i === 0 ? (
                                                <Tr>
                                                    <Td padding={15}>{uc.nome}</Td>
                                                </Tr>
                                            ) : (
                                                <Tr>
                                                    <Td padding={15} style={{ borderTop: "1px #ddd solid" }}>
                                                        {uc.nome}
                                                    </Td>
                                                </Tr>
                                            )
                                        )}
                                    </TBody>
                                );
                            })}
                    </Table>
                </div>
            )}
        </ContentCard>
    );
}

const UsuarioFormRedux = reduxForm({ form: "usuarioForm", destroyOnUnmount: false })(UsuarioForm);
const mapStateToProps = (state) => ({
    formularioValues: getFormValues("usuarioForm")(state),
    usuarioLogado: state.auth.usuarioLogado,
    registro: state.usuario.registro,
    aguardandoClientes: state.cliente.aguardando,
    listaClientes: state.cliente.lista,
    listaClienteSelect: state.cliente.listaSelect,
    listaEmpresa: state.empresa.listaSelect,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ initForm, setModoTela, getListaCliente, getListaEmpresa, getListaClienteSelect }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioFormRedux);
